import { configureStore } from '@reduxjs/toolkit';
import { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';

import { listenerMiddleware } from './app.listener';
import { appReducer } from './app.reducer';
import { baseApi } from './baseApi';

export const createAppStore = (preloadedState?: unknown) =>
  configureStore({
    reducer: appReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      })
        .prepend(listenerMiddleware.middleware)
        .concat(baseApi.middleware),
    devTools: process.env.IS?.development,
    preloadedState,
  });

const store = createAppStore();

export type AppStore = typeof store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const AppStoreProvider = ({ children }: PropsWithChildren) => (
  <Provider store={store}>{children}</Provider>
);
